import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { PersistConfig } from 'redux-persist'
import { storage } from '../core'
import { ProfileState } from './profile.types'

const initialState: ProfileState = {
  firstName: '',
  lastName: '',
  email: '',
  title: '',
  dateOfBirth: '',
  phone: '',
  gender: '',
  location: '',
  avatarUrl: '',
}

export const PROFILE_STATE_NAME = 'profile'

export const profileSlice = createSlice({
  name: PROFILE_STATE_NAME,
  initialState,
  reducers: {
    updateProfile: (state, action: PayloadAction<Partial<ProfileState>>) => {
      return { ...state, ...action.payload }
    },
  },
})

export const profileSliceConfig: PersistConfig<ProfileState> = {
  storage,
  key: PROFILE_STATE_NAME,
  whitelist: [
    'firstName',
    'lastName',
    'email',
    'title',
    'dateOfBirth',
    'phone',
    'gender',
    'location',
    'avatarUrl',
  ],
}

export const { updateProfile } = profileSlice.actions

export default profileSlice.reducer
